import Dashboard from "./Dashboard/Dashboard";

const Home: React.FC = () => {
  return <Dashboard />;
};

export default Home;
